module.exports = "data:image/svg+xml;base64,PHN2Zz4KICA8ZGVmcz4KICAgIDxzeW1ib2wgaWQ9ImhleGFnb24iIG92ZXJmbG93PSJ2aXNpYmxlIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiB2aWV3Qm94PSIwIDggMTAwIDg2Ij4KCTxkZXNjPmhleGFnb248L2Rlc2M+Cgk8cGF0aCBzdHJva2U9ImN1cnJlbnRDb2xvciIKCQlkPSJtMS40MjAwNCw1MC45OTYzNWwyMS4wNzI2MiwtNDIuMTM5NDNsNTYuMTkxNTIsMGwyMS4wNjY3LDQyLjEzOTQzbC0yMS4wNjY3LDQyLjE0NTA3bC01Ni4xOTE1MiwwbC0yMS4wNzI2MiwtNDIuMTQ1MDd6Ii8+CiAgICA8L3N5bWJvbD4KICA8L2RlZnM+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/icons/hexagon.svg
// module id = 701
// module chunks = 0